<template>
  <modal :name="name" :height="'auto'" :width="'400px'">
    <div class="py-2" style="position: relative; width: 100%;">

      <button 
        type="button" 
        class="close" 
        style="position: absolute; top: 0; right: 10px; font-size: 30px;" 
        @click="$modal.hide(name)" 
        aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>

      <h3 class="mb-4 mt-2 mx-3" style="font-size: 16px; font-weight: 600;">{{ title }}</h3>

      <p class="mb-2 mx-3" style="font-size: 14px;">{{ text }}</p>
      <div class="d-flex mx-auto" style="width: 100%; border-top: 1px solid #eee;">
        <button v-for="(btn, index) in buttons" 
                :key="index"
                class="vue-dialog-button"
                style="font-size: 14px;flex: 1 1 50%;"
                @click="handleButton(btn)">
          <i v-if="btn.icon" :class="btn.icon"></i> {{ btn.label }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ContentConfirmModal",
  props: {
    name: { type: String, required: true },
    title: { type: String, default: '' },
    text: { type: String, default: '' },
    buttons: { type: Array, default: () => [] }
  },
  methods: {
    handleButton(btn) {
      if (btn.handler) btn.handler();
      this.$modal.hide(this.name);
    }
  }
}
</script>
